var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"barraConversao"}},[_c('a',{attrs:{"href":"tel:08007044955"}},[_vm._v("ligue 0800 704 4955")])])}]

export { render, staticRenderFns }